import { MenuCategory } from "@/types/common";
import { buildGenderMegaMenuColumns } from "./mega-menu-columns";

/** Prime banner — cột NEW & TRENDING (adidas.com/us MEN, World Cup season) */
export const menMegaMenuBanner = {
  href: "/men-prime_delivery",
  src: "https://brand.assets.adidas.com/image/upload/f_auto,q_auto,fl_lossy/bwp_adidas_content_slot_navigation_d_dfbf3d31ce.png",
  alt: "Fast, free delivery with Prime",
};

export const menMenuData: MenuCategory[] = [
  {
    title: "NEW & TRENDING",
    titleHref: "/men-new_trending",
    items: [
      { name: "New Arrivals", href: "/men-new_arrivals", translationKey: "newArrivals" },
      { name: "Best Sellers", href: "/men-best_sellers", translationKey: "bestSellers" },
      { name: "Trending Now", href: "/men-trending", translationKey: "trendingNow" },
      { name: "Shop FIFA World Cup™", href: "/men-fifa_world_cup", translationKey: "shopFifaWorldCup" },
      { name: "Summer Shop ☀️", href: "/men-summer", translationKey: "summerShop" },
      { name: "Gifts for Every Dad 🧢", href: "/men-gifts_for_dad", translationKey: "giftsForEveryDad" },
      { name: "Pet Collection 🐾", href: "/pet", translationKey: "petCollection" },
      { name: "Pride: Love Unites 🏳️‍🌈", href: "/men-pride", translationKey: "prideLoveUnites" },
      { name: "Spend $100 Save $30", href: "/men-shop", translationKey: "spend100Save30" },
    ],
  },
  {
    title: "SHOES",
    titleHref: "/men-shoes",
    items: [
      { name: "Running", href: "/men-running-shoes", translationKey: "running" },
      { name: "Soccer", href: "/men-soccer-shoes", translationKey: "soccer" },
      { name: "Sneakers", href: "/men-athletic_sneakers", translationKey: "sneakers" },
      { name: "Low Profile", href: "/men-low_profile", translationKey: "lowProfile" },
      { name: "Basketball", href: "/men-basketball-shoes", translationKey: "basketball" },
      { name: "Golf", href: "/men-golf-shoes", translationKey: "golf" },
      { name: "Walking", href: "/men-walking-shoes", translationKey: "walking" },
      { name: "Slides & Sandals", href: "/men-slides", translationKey: "slidesSandals" },
      { name: "Workout & Gym", href: "/men-workout-shoes", translationKey: "workoutGym" },
      { name: "Shoes $80 & Under", href: "/men-under_80-shoes", translationKey: "shoesUnder80" },
    ],
  },
  {
    title: "CLOTHING",
    titleHref: "/men-clothing",
    items: [
      { name: "Pants", href: "/men-pants", translationKey: "pants" },
      { name: "Graphic Tees", href: "/men-graphic_tees", translationKey: "graphicTees" },
      { name: "Shorts", href: "/men-shorts", translationKey: "shorts" },
      { name: "Jerseys", href: "/men-jerseys", translationKey: "jerseys" },
      { name: "Shirts & Tops", href: "/men-tops", translationKey: "shirtsAndTops" },
      { name: "Tracksuits", href: "/men-tracksuits", translationKey: "tracksuits" },
      { name: "Hoodies & Sweatshirts", href: "/men-hoodies_sweatshirts", translationKey: "hoodiesSweatshirts" },
      { name: "Jackets & Coats", href: "/men-jackets_coats", translationKey: "jacketsCoats" },
    ],
  },
  {
    title: "ACCESSORIES",
    titleHref: "/men-accessories",
    items: [
      { name: "Bags & Backpacks", href: "/men-bags_backpacks", translationKey: "bagsBackpacks" },
      { name: "Soccer Balls", href: "/men-soccer_balls", translationKey: "soccerBalls" },
      { name: "Hats & Beanies", href: "/men-hats_beanies", translationKey: "hatsAndBeanies" },
      { name: "Socks", href: "/men-socks", translationKey: "socks" },
      { name: "Underwear", href: "/men-underwear", translationKey: "underwear" },
      { name: "Water Bottles", href: "/men-water_bottles", translationKey: "waterBottles" },
      { name: "Sunglasses", href: "/men-sunglasses", translationKey: "sunglasses" },
    ],
  },
  {
    title: "SPORTS",
    titleHref: "/men-sports",
    items: [
      { name: "Football", href: "/men-football", translationKey: "football" },
      { name: "Baseball", href: "/men-baseball", translationKey: "baseball" },
      { name: "Basketball", href: "/men-basketball", translationKey: "basketball" },
      { name: "Cycling", href: "/men-cycling", translationKey: "cycling" },
      { name: "Golf", href: "/men-golf", translationKey: "golf" },
      { name: "Hiking", href: "/men-hiking", translationKey: "hiking" },
      { name: "Motorsport", href: "/men-motorsport", translationKey: "motorsport" },
      { name: "Outdoor", href: "/men-outdoor", translationKey: "outdoor" },
      { name: "Running", href: "/men-running", translationKey: "running" },
      { name: "Soccer", href: "/men-soccer", translationKey: "soccer" },
      { name: "Tennis", href: "/men-tennis", translationKey: "tennis" },
      { name: "Workout & Gym", href: "/men-workout_gym", translationKey: "workoutGymSport" },
      { name: "Yoga", href: "/men-yoga", translationKey: "yoga" },
    ],
  },
  {
    title: "COLLECTIONS",
    titleHref: "/men-collections",
    items: [
      { name: "adicolor", href: "/men-adicolor", translationKey: "adicolor" },
      { name: "Campus", href: "/men-campus", translationKey: "campus" },
      { name: "Premium Collaborations", href: "/men-premium", translationKey: "premiumCollaborations" },
      { name: "Five Ten", href: "/men-five_ten", translationKey: "fiveTen" },
      { name: "Gazelle", href: "/men-gazelle", translationKey: "gazelle" },
      { name: "Samba", href: "/men-samba", translationKey: "samba" },
      { name: "Superstar", href: "/men-superstar", translationKey: "superstar" },
      { name: "Sportswear", href: "/men-sportswear", translationKey: "sportswear" },
      { name: "Firebird", href: "/men-firebird", translationKey: "firebird" },
      { name: "TERREX", href: "/men-terrex", translationKey: "terrex" },
      { name: "Ultraboost", href: "/men-ultraboost", translationKey: "ultraboost" },
      { name: "Y-3", href: "/men-y-3", translationKey: "y3" },
      { name: "ZNE", href: "/men-zne", translationKey: "zne" },
    ],
  },
];

export const menMenuColumns = buildGenderMegaMenuColumns(menMenuData, {
  shopByColorAfterHeading: "CLOTHING",
});
